import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from "jquery";
import SelectCellSelosSelagem from "./mySelectCellSelosSelagem"
import SelectCellEtiquetasSelagem from "./mySelectCellEtiquetasSelagem"
import TipoOptionForm from './TipoOptionForm';
var optionsEntidade = [];

class DropDownCellNVasilha extends Component {
  
  handleChange = e => {
    this.props.onChange({
        dataIndex: 0,
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value
    });
    
  }
 
  handleChangeSelagem = e => {
    this.props.onChange({
        dataIndex: 0,
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value
    });
    SelectCellEtiquetasSelagem.changeValueFromSelectNumeroVasilha(e)
    SelectCellSelosSelagem.changeValueFromSelectNumeroVasilha(e)
  }
  
  static ChangeValueById(value){

    optionsEntidade = [];
      (async () => {
          const data = {"IDTipoVasilha" : value, "IDInstalacaoVinica" : $('#instal_vinica_auto').val().split('!')[0]}
          const Vasilha = await services.apiCall.requestApi(
              "/Fiscalizacao/GetNVasilha",
              data,
              "get"
          );
            
          if(Vasilha){
            Vasilha.map((tipo) => (
              optionsEntidade.push({text: tipo.numeroVasilha, value: tipo.idVasilha, CapacidadeCalculada: tipo.capacidadeCalculada})
            ));
          }
    })();

  }

  render() {

    console.log('thisDropDownCellNVasilha');

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null || dataItem[field] === undefined ? null : dataItem[field];

    // if(optionsEntidade.length <= 0 && dataValue != null ){
    //   dataValue.text = '';
    // }

    return (
      field == "N_Vasilha_granel" ?
        <td>
          {dataItem.inEdit ?
          <DropDownList
            popupSettings={{
              width: 'max-content',
            }}
            onChange={this.handleChangeSelagem}
            value={optionsEntidade.length > 0 ? optionsEntidade.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null)) : dataItem.N_Vasilha_granel}
            data={optionsEntidade}
            textField="text"
            id='id-DropDownCellNVasilha'
          />
          : dataValue != null || dataValue != undefined ? dataValue.text.toString() : undefined}
        </td>
      :
        <td>
          {dataItem.inEdit ?
          <DropDownList
            popupSettings={{
              width: 'max-content',
            }}
            onChange={this.handleChange}
            value={optionsEntidade.length > 0 ? optionsEntidade.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null)) : dataItem.N_Vasilha}
            data={optionsEntidade}
            textField="text"
            id='id-DropDownCellNVasilha'
          />
          : dataValue != null || dataValue != undefined ? dataValue.text.toString() : undefined}
        </td>
    );

  }
}



export default DropDownCellNVasilha;